import * as Constants from '../components/common/Constants'

const initialState = {
    leads: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Constants.SET_PRODUCT_NAME:
            return {
                ...state,
                leads: action.payload
            };
        default:
            return state;
    }
};

export default reducer;
